<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>领导评分</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-tabs v-model="activeName">
                
                <el-tab-pane label="月度" name="month">
                    <JugeListByLeader :pt="0"></JugeListByLeader>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <JugeListByLeader :pt="1"></JugeListByLeader>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import JugeListByLeader from "../KPI/JugeListByLeader";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
export default {
  data() {
    return {
      currentRole:{},//当前用户角色
      activeName: "month",
    };
  },

created() {
   
     //获取当前用户角色
    this.getCurrentRole();
   console.log(this.currentRole);
   this.centerHead();
  },
 methods: {
 
             //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },

    centerHead:function(){
        if(this.currentRole.RoleName=="中心负责人"||this.currentRole.RoleName=="CEO"){
                this.activeName="quarter";
        }
    }



 },
  components: {
    JugeListByLeader
  }
}
</script>

